var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "query-item" }, [
    _c(
      "div",
      { staticClass: "query-string-wrapper" },
      [
        !_vm.isExpanded
          ? _c(
              "div",
              { staticClass: "shortened-query query-container" },
              [
                _c("query-string", {
                  attrs: { lines: _vm.queryLinesFormattedShort },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("transition-height", { attrs: { duration: 750 } }, [
          _vm.isExpanded
            ? _c(
                "div",
                { staticClass: "expanded-query query-container" },
                [
                  _c("query-string", {
                    attrs: { lines: _vm.queryLinesFormattedFull },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "query-footer" }, [
          _vm.query.is_expandable
            ? _c(
                "a",
                {
                  staticClass: "item",
                  attrs: {
                    title: _vm.isExpanded
                      ? _vm.$gettext("Collapse")
                      : _vm.$gettext("Expand"),
                  },
                  on: {
                    click: function ($event) {
                      _vm.isExpanded = !_vm.isExpanded
                    },
                  },
                },
                [
                  !_vm.isExpanded
                    ? _c("icon", { attrs: { name: "fas fa-chevron-down" } })
                    : _c("icon", { attrs: { name: "fas fa-chevron-up" } }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "item" },
            [
              _c("icon", { attrs: { name: "fas fa-stopwatch" } }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.query.durationDisplay) +
                  "\n            "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "separator" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "item" },
            [
              _c("icon", { attrs: { name: "fas fa-history" } }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.query.timestampDisplay) +
                  "\n            "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "separator" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "item",
              class: { "has-text-danger": _vm.isCurrentRequest },
            },
            [
              _c("icon", { attrs: { name: "fas fa-link" } }),
              _vm._v(" "),
              _vm.query.request_path == null
                ? [
                    _c("i", { staticClass: "has-text-grey" }, [
                      _vm._v(_vm._s(_vm.$gettext("N/A"))),
                    ]),
                  ]
                : [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.query.request_path) +
                        "\n                "
                    ),
                  ],
            ],
            2
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }